import ReactApexChart from "react-apexcharts";
import React from "react";
import {CustomOptionsConfig} from "./CustomOptionsConfig";
import {useTranslation} from "react-i18next";
import NotPermissionComponent from "../../dashboard/NotPermissionComponent";
import {SerieGraph} from "../../../services/interface/catalogs/serie-graph";
import {ApexOptions} from "apexcharts";
import {Skeleton} from "../../../components/general/Skeleton";
import CustomSelect from "../../../components/general/CustomSelect";

interface Props {
    className?: string;
    title?: string;
    service: string;
    loading: boolean;
    error?: Error | null;
    response?: any;
    options?: ApexOptions;
    series?: SerieGraph[];
    option: any;
    setOption: React.Dispatch<React.SetStateAction<any>>;
    optionsSelect: any;
}

export default function CustomGraphicChart({
                                               className,
                                               title,
                                               service,
                                               loading,
                                               error,
                                               response,
                                               series,
                                               options,
                                               option,
                                               setOption,
                                               optionsSelect
                                           }: Props) {
    const {t} = useTranslation("global") as { t: (key: string) => string };

    return (
        <>
            {title && <h3>{title}</h3>}
            <NotPermissionComponent
                className={loading && !title ? 'grid w-full px-2 pb-2' : ''}
                title={service}
                loading={loading}
                error={error}
                component={
                    <>
                        {
                            !loading && response && options && series ?
                                <div className={`w-full h-full grid ${className}`}>
                                    <ReactApexChart options={options} series={series} height={350}/>
                                    <CustomSelect
                                        disabled={loading}
                                        classNameContainer={'-mt-5 max-w-[200px] ml-2 mb-1'}
                                        className={'!border !border-transparent'}
                                        value={option}
                                        setValue={setOption}
                                        options={optionsSelect}
                                    />
                                </div> : !response ?
                                    <div className={`w-full h-full grid ${className}`}>
                                        <ReactApexChart options={CustomOptionsConfig} series={[]} height={350}/>
                                        <div className={'-mt-8 max-w-[200px] ml-4 mb-3 text-[12px]'}>{t('no-records')}</div>
                                    </div>
                                    :
                                    <div className={`grid w-full h-full px-2 pb-2`}>
                                        <Skeleton className={'min-h-[380px]'}/>
                                    </div>
                        }
                    </>
                }
            />
        </>
    )
}
